<div class="bn-dashboard-user-profile">
  @if (isMobile) {
    <div class="bn-dashboard-user-profile--mobile">
      <img
        class="bn-dashboard-user-profile__avatar"
        email="{{ email }}"
        ngxGravatar
        [size]="30" />
      @if (accountRoute) {
        <a
          class="bn-dashboard-user-profile__link"
          routerLinkActive="bn-dashboard-user-profile__link--active"
          [routerLink]="accountRoute"
          >{{ fullName }}</a
        >
      } @else {
        <span class="bn-dashboard-user-profile__link">{{ fullName }}</span>
      }
    </div>
  }

  @if (!isMobile) {
    <bn-web-ui-dropdown-menu
      [aboveLoader]="true"
      [items]="menuItems"
      [options]="{
        align: 'start',
        size: 'sm',
        indent: '-18px',
        attachArrow: true,
      }"
      (clickAction)="onItemClick($event)">
      <span trigger>
        <img
          email="{{ email }}"
          ngxGravatar
          [size]="24" />
      </span>
      <div
        class="bn-dropdown"
        content-top>
        <div class="bn-dropdown__header">
          <div>
            @if (accountRoute) {
              <a
                class="text-200-semi-bold"
                [routerLink]="accountRoute"
                >{{ fullName }}</a
              >
            } @else {
              <span class="text-200-semi-bold">{{ fullName }}</span>
            }
          </div>
          <span
            class="user-select-auto"
            [title]="email + '\nClick to copy'"
            (click)="copyToClipboard()"
            >{{ email }}</span
          >
        </div>
        @if (showBilling) {
          <hr class="bn-dropdown__divider" />
          <div class="bn-dropdown__item">
            @if (billingRoute) {
              <a
                class="bn-dropdown__item-link"
                [routerLink]="billingRoute">
                <fa-icon
                  class="bn-dropdown__icon"
                  icon="circle-dollar" />
                <span>Billing</span>
                @if (billingBalance) {
                  <bn-web-ui-badge
                    color="green"
                    contentClass="float-end"
                    size="xs"
                    >{{ billingBalance | currency }}</bn-web-ui-badge
                  >
                }
              </a>
            }
          </div>
          <hr class="bn-dropdown__divider" />
        }
      </div>
    </bn-web-ui-dropdown-menu>
  }
</div>
